export default __webpack_public_path__ + "static/media/draft2.9694eed9.svg";